import { createSlice } from "@reduxjs/toolkit";

export const mapDataSelectedSlice = createSlice({
    name: 'mapdata',
    initialState: {
        value: {}
    },
    reducers: {
        setMapDataSelected: (state, action) => {
            state.value = action.payload;
        }
    }
})

export const { setMapDataSelected } = mapDataSelectedSlice.actions;

export const getMapDataSelected = (state) => state.mapdata.value;

export default mapDataSelectedSlice.reducer;